import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
export var TextChip = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 500 !important;\n  color: #000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));